import { responsiveFontSizes } from '@mui/material';
import {createContext,useState } from 'react'
import {  useNavigate } from 'react-router-dom';
const axios = require('axios');
export const RowContext = createContext();

const api = axios.create({
    baseURL: "http://localhost:5000/api/"
})


export const BatchContextProvider = ({children}) => {
       
        
        const [updateId , setUpdateId] = useState(0);
        const [batchState , setBatchState] = useState({})
        const [sectionError,setSectionError] = useState({value:false,text:""})
        const [secError,setSecError] = useState({value:false,text:""})
        
        const [isNavigate,setIsNavigate] = useState(1)
        
            
        

    return(
    <RowContext.Provider value={{updateId , setUpdateId,batchState,setBatchState}}>
        {children}
    </RowContext.Provider>
    )
}
